import { getRequestPhase } from '../../../../api'
import { useAsyncCallback } from '../../../../hooks'
import { EntityAsyncMultiValuedListMoreItems } from '../../../Entity'
import { MultiValuedList } from '../../../MultiValuedList'
import { TextMultiValuedListItem } from '../../../TextMultiValuedList'
import { RequestPhaseAsyncMultiValuedListMoreItem } from '../RequestPhaseAsyncMultiValuedListMoreItem'

import {
  getDataItems,
  phaseFilterByName,
} from './RequestPhaseAsyncMultiValuedList.utils'

function RequestPhaseAsyncMultiValuedList({
  Item = TextMultiValuedListItem,
  MoreItem = RequestPhaseAsyncMultiValuedListMoreItem,
  MoreItems = EntityAsyncMultiValuedListMoreItems,
  filter = phaseFilterByName,
  id,
  ...restProps
}) {
  const handleLoadData = useAsyncCallback(() => {
    return getRequestPhase({ id })
  }, [id])

  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      MoreItem={MoreItem}
      MoreItems={MoreItems}
      filter={filter}
      moreItemsProps={{
        getData: handleLoadData,
        getDataItems,
      }}
    />
  )
}

export default RequestPhaseAsyncMultiValuedList
